module.exports = __webpack_public_path__ + "static/img/add_big.db79e40.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/add_big.png
// module id = fu0B
// module chunks = 3